export var valuesDashboardPackingMode = ["None", "Vertical", "Horizontal"];
/*

*/ 
//# sourceMappingURL=DashboardPackingMode.js.map